module.exports = __webpack_public_path__ + "img/25200.7a1214dd.jpg";